import { Typography } from '@mui/material';

export const EntryWithHeadline = ({
  headline,
  entry,
  bold
}: {
  headline: string;
  entry?: string;
  bold?: boolean;
}) => {
  return (
    <>
      <Typography component="h3">{headline}</Typography>
      <Typography sx={bold ? { fontWeight: 'bold' } : undefined}>{entry}</Typography>
    </>
  );
};
